import React, { Component } from 'react';
import { Container, Responsive } from 'semantic-ui-react';

export default class InvertedContainer extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <Responsive minWidth={Responsive.onlyTablet.minWidth}>
                    <div className="mpost-section--inverted">
                        <Container textAlign={this.props.textAlign} className="mpost-section">
                            {this.props.children}
                        </Container>
                    </div>
                </Responsive>
                <Responsive {...Responsive.onlyMobile}>
                <div className="mpost-section--inverted">
                        <Container textAlign={this.props.textAlign} className="mpost-section mobile">
                            {this.props.children}
                        </Container>
                    </div>
                </Responsive>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/InvertedContainer.js